__turbopack_context__.v({
  "className": "inter_c452a868-module__ZqBHxG__className",
  "variable": "inter_c452a868-module__ZqBHxG__variable",
});
